import StoreCommon from '@/app-core/mixins/store/storeCommon'

export default {
  name      : 'AppFooter',
  components: {},
  directives: {},
  mixins    : [StoreCommon],
  props     : {
    simple: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {
    AppVersion: 'App.Version',
    AppConfig : 'App.Config',
    AppStores : 'App.Stores'
  },
  data() {
    return {
      showVersion: false,
      policies   : []
    }
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
    this.$vuetify.theme.dark = this.$localStorage.get('dark', this.AppConfig?.Theme?.Dark || this.$vuetify.theme.dark)
    document.documentElement.classList.toggle('cc--darkmode', this.$vuetify.theme.dark)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onStoreClick(store) {
      if (this.$route.name === 'Store') {
        this.$bus.$emit('store:selected', store)
      } else {
        this.$router.push({
          name  : 'Store',
          params: {
            slug: store.Slug,
            id  : store.Id
          }
        })
      }
    },

    toggleCookiesPrefs() {
      this.$cc.showPreferences()
    },

    toggleThemeDark() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.$localStorage.set('dark', this.$vuetify.theme.dark)
      document.documentElement.classList.toggle('cc--darkmode', this.$vuetify.theme.dark)
    }
  }
}
